// extracted by mini-css-extract-plugin
export default {"zr-setting-box":"GlobalSettings_zr-setting-box__sAPvJ","zr-save-setting-btn":"GlobalSettings_zr-save-setting-btn__lTzsD"};